import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { HiCheckCircle, HiShieldCheck,  HiChatAlt } from 'react-icons/hi';
import useSectionView from '../utils/useSectionView';
import '../styles/About.css';

const About = () => {
  const sectionRef = useSectionView('about');
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.5,
      }
    },
  };

  return (
    <section className="about" id="about" ref={sectionRef}>
      <motion.div
        ref={ref}
        className="about-container"
        variants={containerVariants}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
      >
        <motion.h2 className="section-title" variants={itemVariants}>
          Why Buy From Us
        </motion.h2>

        <motion.p className="about-intro" variants={itemVariants}>
          India's most trusted online destination for certified astrological gemstones. 
          We combine ancient Vedic wisdom with modern quality standards.
        </motion.p>

        <div className="about-content">
          <motion.div className="about-card" variants={itemVariants}>
            <div className="card-icon">
              <HiShieldCheck />
            </div>
            <h3>100% Authentic & Certified</h3>
            <p>
              Every gemstone comes with a lab certificate from internationally recognized 
              gemological institutes. We guarantee natural, untreated stones with complete 
              transparency on origin, quality, and treatment (if any).
            </p>
            <div className="card-features">
              <span className="feature-tag">✓ IGI Certified</span>
              <span className="feature-tag">✓ Natural Stones</span>
              <span className="feature-tag">✓ Quality Tested</span>
            </div>
          </motion.div>

          <motion.div className="about-card" variants={itemVariants}>
            <div className="card-icon">
              <HiCheckCircle />
            </div>
            <h3>Vedic Energization Process</h3>
            <p>
              All our gemstones are purified and energized by experienced Vedic priests 
              following traditional rituals. Each stone is charged on auspicious days 
              according to its ruling planet for maximum astrological benefit.
            </p>
            <div className="card-features">
              <span className="feature-tag">✓ Mantra Charged</span>
              <span className="feature-tag">✓ Puja Performed</span>
              <span className="feature-tag">✓ Vedic Methods</span>
            </div>
          </motion.div>

          <motion.div className="about-card" variants={itemVariants}>
            <div className="card-icon">
              <HiChatAlt />
            </div>
            <h3>Expert Astrology Support</h3>
            <p>
              Get FREE consultation from certified Vedic astrologers. We analyze your 
              birth chart and recommend the perfect gemstone, wearing method, and timing 
              for maximum effectiveness. Lifetime support included with every purchase.
            </p>
            <div className="card-features">
              <span className="feature-tag">✓ Free Consultation</span>
              <span className="feature-tag">✓ Chart Analysis</span>
              <span className="feature-tag">✓ Lifetime Support</span>
            </div>
          </motion.div>
        </div>

        {/* Stats Section */}
        {/* <motion.div className="stats-section" variants={itemVariants}>
          <div className="stat-item">
            <h3 className="stat-number">10+</h3>
            <p className="stat-label">Happy Customers</p>
          </div>
          <div className="stat-item">
            <h3 className="stat-number">12+</h3>
            <p className="stat-label">Gemstones Sold</p>
          </div>
          <div className="stat-item">
            <h3 className="stat-number">4.7★</h3>
            <p className="stat-label">Average Rating</p>
          </div>
          <div className="stat-item">
            <h3 className="stat-number">100%</h3>
            <p className="stat-label">Certified Authentic</p>
          </div>
        </motion.div> */}
      </motion.div>
    </section>
  );
};

export default About;